import { getText } from "shared/lib";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "shared/components";

export interface MultiLingualToastProps {
  onClose?: () => void;
}

export function MultiLingualToast({ onClose }: MultiLingualToastProps) {
  return (
    <ToastProvider>
      <Toast
        duration={99999999999999999}
        className="flex flex-col items-start border-none"
      >
        <ToastTitle>{getText("🤖 ️Translations are AI-generated")}</ToastTitle>
        <ToastDescription>
          {getText(
            "They can sometimes contain errors. Your final report will also be available in English, which may be more reliable for planners to review.",
          )}
        </ToastDescription>
        <ToastClose onClick={onClose} />
      </Toast>
      <ToastViewport />
    </ToastProvider>
  );
}
